import { useToggle } from "@mantine/hooks"
import CustomSpinner from "components/Atoms/CustomSpinner"
import SubHeader from "components/Organisms/SubHeader"
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import { useRouteAssignmentDetailLazyQuery } from "generated/graphql"
import useRouteStore from "pages/fsm/routes.store"
import React, { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import AddVendorView from "./AddVendorView"
import BeatForm from "./BeatForm"
dayjs.extend(customParseFormat)
const BeatCreationPage = () => {
  const { id } = useParams<{ id }>()
  const idInt = parseInt(id)
  const [isEditable, toggleEditable] = useToggle(
    idInt ? [false, true] : [true, false]
  )

  const navigate = useNavigate()
  const store = useRouteStore()
  const [getDetails, { loading, data }] = useRouteAssignmentDetailLazyQuery({
    onCompleted({ routeAssignmentDetail: d }) {
      /**
       * Get the list of all the outlets and normalize it
       */
      const outlets = d.route.points.map(p => ({
        ...p.visitee,
      }))

      /**
       * Normalize assigned route points
       * If there are assigned route points already then keep them as selected
       * else select all the route points by default
       */
      const assignedOutlets = d.assignedRoutePoints.length
        ? d.assignedRoutePoints.map(p => ({
            sequence: p.sequence,
            ...p.visitee,
          }))
        : d.route.points.map(p => ({
            sequence: p.sequence,
            ...p.visitee,
          }))

      store.initialiseState({
        step: "select",
        id: d.id,
        startDate: d.startDate,
        startTime: dayjs(d.startTime, "hh:mm:ss").toDate(),
        endTime: dayjs(d.endTime, "hh:mm:ss").toDate(),
        route: d.route,
        recurrence: d.rrules,
        asignee: d.assignee,
        surveyArea: d.route.surveyArea,
        outlets: outlets,
        selectedOutlets: assignedOutlets,
        optimizeRoute: true,
        colorCode: d.route.colorCode,
      })
    },
  })

  useEffect(() => {
    if (idInt) {
      getDetails({ variables: { id: idInt.toString() } })
    }
  }, [getDetails, idInt])

  if (loading) return <CustomSpinner />

  const surveyArea = data?.routeAssignmentDetail?.route.surveyArea
  const allLink = `/d/fsm/beat?sid=${surveyArea?.id}&sname=${surveyArea?.properties?.name}`
  return (
    <SubHeader
      showBackButton={false}
      breadrumbs={[
        {
          href: allLink,
          onClick(e) {
            e.preventDefault()
            navigate(allLink)
          },
          text: "Beat",
        },
        {
          href: `/d/fsm/beat/${id}`,
          onClick(e) {
            e.preventDefault()
            navigate(`/d/fsm/beat/${id}`)
          },
          text: data?.routeAssignmentDetail?.route?.name || id,
        },
      ]}
    >
      <BeatForm isEditable={isEditable} toggleEditable={toggleEditable} />
      {data?.routeAssignmentDetail?.id && (
        <AddVendorView disabled={isEditable} />
      )}
    </SubHeader>
  )
}
export default BeatCreationPage
